import styled from 'styled-components';
import { colors } from 'constants/styles/colors';
import Icon from 'components/icons';
import { screenMd } from 'constants/styles/breakpoints';

export const Filters = styled.div`
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 12px;
  gap: 5px;

  ${screenMd} {
    height: 60px;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: unset;
  }
`;

export const FilterTitle = styled.div`
  color: ${colors.fonts.dark};
  font-family: var(--font-family-base);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;

  ${screenMd} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const TypeFiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 62px repeat(2, 150px);

  ${screenMd} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 30px;
  }
`;

export const SingleFilterContainer = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
  span {
    font-size: 10px;
  }
  ${screenMd} {
    margin-left: 20px;
    span {
      font-size: unset;
    }
  }
  .ant-radio-input:not(:checked) {
    border: none !important;
  }
  .ant-radio-input {
    width: 20px !important;
    height: 20px !important;
  }
  .ant-radio-input:checked:after {
    top: 4px !important;
    left: 4px !important;
  }
  .ant-radio-input:checked {
    background-color: #d0d2db !important;
  }
`;

export const InfoIcon = styled(Icon)<{ fill?: string }>`
  fill: ${colors.secondaryPallete.purple.light};
  &:hover {
    fill: ${colors.secondaryPallete.purple.base};
  }
`;
